var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import MoveTo from 'moveto';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import Modal from '@declaration/components/UI/Modal.vue';
import ExternalDamageLocalization from '@declaration/components/externalDamage/ExternalDamageLocalization.vue';
import ExternalDamagePictures from '@declaration/components/externalDamage/ExternalDamagePictures.vue';
import ExternalDamageDescription from '@declaration/components/externalDamage/ExternalDamageDescription.vue';
import { ANIMATION_DURATIONS } from '@declaration/animations/utils';
import { EXTERNAL_DAMAGE_SLUG_TO_DESCRIPTION_COMPONENT, } from '@declaration/constants/externalDamages';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const settings = namespace('settings');
const qualification = namespace('qualification');
let ExternalDamageModal = class ExternalDamageModal extends ExternalDamageComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.validateRequested = false;
    }
    get descriptionComponent() {
        return this.externalDamage.slug
            ? EXTERNAL_DAMAGE_SLUG_TO_DESCRIPTION_COMPONENT[this.externalDamage.slug]
            : null;
    }
    get showExternalDamageDescription() {
        return !!this.externalDamage.localizationSlug && !!this.externalDamage.slug;
    }
    get hasDisableDamagesPictures() {
        return insurerHasFeature(InsurerFeatureFlag.DisableDamagesPictures);
    }
    get requiredPhotosCount() {
        if (!this.setting || !this.trigram)
            return 0;
        const grouped = this.setting('damageRequiredPhotosCount');
        let rawValue = null;
        if (grouped && typeof grouped === 'object') {
            rawValue = grouped[this.trigram];
        }
        const value = Number(rawValue);
        return isNaN(value) ? 0 : value;
    }
    get isPhotoRequirementMet() {
        var _a, _b, _c;
        if (this.requiredPhotosCount === 0)
            return true;
        const collection = this.externalDamage.pictureCollection;
        if (!collection || typeof collection === 'string')
            return false;
        const files = (_c = (_a = collection.uploadedAppFiles) !== null && _a !== void 0 ? _a : (_b = collection.data) === null || _b === void 0 ? void 0 : _b.uploadedAppFiles) !== null && _c !== void 0 ? _c : [];
        return files.length >= this.requiredPhotosCount;
    }
    get isExternalDamageValidWithPhotos() {
        const baseValid = super.isExternalDamageValid;
        if (this.requiredPhotosCount === 0 || this.hasDisableDamagesPictures) {
            return baseValid;
        }
        return baseValid && this.isPhotoRequirementMet;
    }
    created() {
        this.$watch('externalDamageSlug', (externalDamageSlug) => this.moveToRefOnWatchedValueChange(externalDamageSlug, 'description'));
    }
    moveToRefOnWatchedValueChange(watchedValue, ref) {
        if (watchedValue) {
            this.$nextTick(() => {
                // Scroll is relative to Modal content
                const container = this.$children[0].$refs.content;
                if (!container || !this.$refs[ref]) {
                    return;
                }
                const moveTo = new MoveTo({
                    tolerance: 180,
                    duration: ANIMATION_DURATIONS.Long * 1000,
                    container,
                });
                moveTo.move(this.$refs[ref]);
            });
        }
    }
    revealValidation() {
        this.$store.dispatch('error/add', 'Veuillez remplir tous les champs obligatoires');
        this.validateRequested = true;
    }
    closeModal() {
        this.validateRequested = false;
        this.$emit('close');
    }
    async save() {
        try {
            this.isSaving = true;
            await this.saveExternalDamage();
            this.closeModal();
        }
        catch (err) {
            this.$store.dispatch('error/add', 'Une erreur est survenue, merci de réessayer.');
        }
        finally {
            this.isSaving = false;
        }
    }
    onClose() {
        this.resetChanges();
        this.closeModal();
    }
    onGoBack() {
        this.updateExternalDamageLocalization(null);
    }
};
__decorate([
    settings.Getter('setting')
], ExternalDamageModal.prototype, "setting", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], ExternalDamageModal.prototype, "trigram", void 0);
ExternalDamageModal = __decorate([
    Component({
        components: {
            Modal,
            ExternalDamageLocalization,
            ExternalDamageDescription,
            ExternalDamagePictures,
            UiButton,
        },
        props: {
            isDisplayed: { type: Boolean, required: true },
        },
    })
], ExternalDamageModal);
export default ExternalDamageModal;
